module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "btn-group multi-select",
    class: {
      'show': _vm.openSuggestion
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: _vm.triggerClass,
    domProps: {
      "innerHTML": _vm._s(_vm.displaySelected)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpen($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-trigger",
    class: _vm.triggerClass,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleOpen($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasEmpty),
      expression: "hasEmpty"
    }],
    on: {
      "click": function($event) {
        _vm.suggestionClick(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.placeholder || ' - '))]), _vm._v(" "), _vm._l((_vm.list), function(suggestion, i) {
    return _c('li', {
      domProps: {
        "innerHTML": _vm._s(_vm.display(suggestion))
      },
      on: {
        "click": function($event) {
          _vm.suggestionClick(suggestion)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e389d85e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/Dropdown.vue
// module id = 423
// module chunks = 0